import { BlocksIconAdd } from 'blocks-nextjs/blocks-web-components/components/icon/icons/add';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconAdd = createComponent({ react: React, tagName: 'cat-icon-add', elementClass: BlocksIconAdd });
